var sideNavScroll = {};

$(document).ready(function () {
    if (!window.enableJSDebugMode) {
        if ($(".side-nav").length > 0) {
            sideNavScroll.inst = new logicjs.fixedScrollAlt({
                fixedElement: ".side-nav",
                adjacentElement: ".content-area",
                fixedClass: "fixed",
                absoluteClass: "absolute"
            });
        }
    }
});
